import fetch from 'unfetch';
import {v4 as uuid} from 'uuid';

const submitReportAndUploadFile = async (values, siteName, isManagerIntervention = false) => {
  if (!values.file) {
    fetch('/api/submissions', {
      method: 'POST',
      body: JSON.stringify({
        site: siteName || 'N/A',
        submitterName: values.name || 'N/A',
        locationFirst: values.phase || 'N/A',
        locationSecond: values.block || 'N/A',
        locationThird: values.level || 'N/A',
        description: values.comment || 'N/A',
        closeoutComment: values.closeoutComment || 'N/A',
        clouseoutCheckbox: values.clouseoutCheckbox || 'N/A',
        descriptionRomainian: values.commentRomanian || 'N/A',
        photoName: '',
        language: values.language || 'N/A',
        isManagerIntervention,
        category: values.category || 'N/A',
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/html',
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        Promise.resolve(res);
      })
      .catch((err) => Promise.reject(err));
  } else {
    const fileName = `${uuid()}-${values.file.name}`;
    fetch('/api/get-signed-url', {
      method: 'POST',
      body: JSON.stringify({fileName, type: values.file.type}),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/html',
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        console.log(res.signedRequest);
        fetch(`${res.signedRequest}`, {
          method: 'PUT',
          headers: {
            'Content-Type': values.file.type,
            'x-amz-acl': 'public-read',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Request-Method': 'PUT',
            'Access-Control-Allow-Credentials': true,
            Origin: 'http://localhost:3000',
          },
          body: values.file,
        })
          .then((res) => {
            fetch('/api/submissions', {
              method: 'POST',
              body: JSON.stringify({
                site: siteName || 'N/A',
                submitterName: values.name || 'N/A',
                locationFirst: values.phase || 'N/A',
                locationSecond: values.block || 'N/A',
                locationThird: values.level || 'N/A',
                description: values.comment || 'N/A',
                closeoutComment: values.closeoutComment || 'N/A',
                clouseoutCheckbox: values.clouseoutCheckbox || 'N/A',
                descriptionRomainian: values.commentRomanian || 'N/A',
                photoName: fileName,
                isManagerIntervention,
                category: values.category || 'N/A',
              }),
              headers: {
                'Content-Type': 'application/json',
                Accept: 'text/html',
              },
            })
              .then((res) => {
                return res.json();
              })
              .then((res) => {
                Promise.resolve(res);
              })
              .catch((err) => Promise.reject(err));
          })
          .catch((error) => Promise.reject(error));
      })
      .catch((err) => Promise.reject(err));
  }
};

export default submitReportAndUploadFile;



// WEBPACK FOOTER //
// ./src/helpers/submitReportAndUploadFile.js